// Backend-owned label maps.
//
// Some values come from the API as opaque IDs (leave.type, notification.type,
// notification.template_key, etc.). Look them up here by ID rather than
// rendering raw backend strings.
//
// NOTE: Notification `title` and `message` are currently populated directly by
// the backend at insert time (see backend/services/notifications.js) and stored
// as plain text in the DB. Until the backend switches to sending template_key
// + params, we cannot swap those to t() on the frontend. This file provides a
// mapping shell so the swap becomes trivial once the backend change lands.

const dict = {
  uk: {
    leaveType: {
      vacation: 'Відпустка',
      sick: 'Лікарняний',
      force_majeure: 'Форсмажор',
    },
    // Placeholders for future template_key -> localized title/message mappings.
    // Backend currently hard-codes UK strings; leaving stubs so components can
    // fall back to `notif.title` / `notif.message` if no mapping exists.
    notifications: {
      // e.g. payment_received: { title: '...', message: '...' },
    },
  },
  en: {
    leaveType: {
      vacation: 'Vacation',
      sick: 'Sick leave',
      force_majeure: 'Force majeure',
    },
    notifications: {},
  },
};

export default dict;
